// extracted by mini-css-extract-plugin
module.exports = {"container":"ParentTrails_container__UiCwZ","iconContainer":"ParentTrails_iconContainer__XKm7n"};